import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

function BlockContextColor({ previewItem, showIcon }) {
  const iconName = get(previewItem, 'title', '').toLowerCase().replace(' ', '-');
  return (
    <div className={`quick-results-preview__item_image quick-results-preview__item_image-${iconName}`}>
      {showIcon && (
        <svg className="rx-btn-icon svg-icon">
          <use xlinkHref={`#icon-${iconName}`} />
        </svg>
      )}
    </div>
  );
}

BlockContextColor.propTypes = {
  previewItem: PropTypes.object.isRequired,
  showIcon: PropTypes.bool,
};

export default BlockContextColor;
